import { News, NewsListParamsType, NewsType } from "@/types/News";
import { getConfig } from "@/utils/config";
import { HttpResponse } from "@/utils/http-client";
import useSWR from "swr";

export function useGetNewsList({
  type,
  start_time_to,
  end_time_from,
}: NewsListParamsType) {
  return useSWR<NewsType[], HttpResponse<any, any>>(
    "getNewsList" + type + start_time_to + end_time_from,
    async () => {
      const params = { type, start_time_to, end_time_from };
      for (const key of Object.keys(params)) {
        if (!params[key as keyof typeof params]) {
          delete params[key as keyof typeof params];
        }
      }
      const courses = new News(getConfig());
      return (await courses.newsList(params)).data;
    },
    {
      revalidateOnFocus: false,
    }
  );
}
